import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Button, Stack, TextField, Tooltip } from "@mui/material";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../app/hooks";
import { LoadState } from "../../../redux/common";
import { findRoutineCommentRequest, routineCommentChange, RoutineCommentChangeRequest, selectRoutineCommentChange } from "../../../redux/routine/routineCommentChangeSlice";
import { RoutineItemInfo } from "../../../redux/routine/routineItemSlice";

interface RoutineCommentCellProps {
    eventDate: string;
    schoolId: string;
    classroomId: string;
    studentId: string;
    item: RoutineItemInfo;
    routineComment?: string;
}

const RoutineCommentCell = ({
    eventDate,
    schoolId,
    classroomId,
    studentId,
    item,
    routineComment
}: RoutineCommentCellProps) => {
    const dispatch = useAppDispatch();
    const commentChange = useSelector(selectRoutineCommentChange);
    // state to keep the comment being edited, to avoid losing the comment when the change is in progress
    const [editingComment, setEditingComment] = useState<string>(routineComment || "");

    const foundRequest = findRoutineCommentRequest(commentChange.requests, {
        schoolId: schoolId,
        classroomId: classroomId,
        studentId: studentId,
        eventDate: eventDate,
        routineId: item.routineId
    });
    const changing = foundRequest?.state.state === LoadState.Loading;

    const changed = useMemo(() => {
        console.log(`Comparing comments: current=${routineComment || ""}, editing=${editingComment}, changed=${`${routineComment || ""}` != `${editingComment}`}`);
        return `${routineComment || ""}` != `${editingComment}`;
    }, [routineComment, editingComment]);

    const handleSave = () => {
        console.log(`Option clicked: itemId=${item.id}, comment=${editingComment}`);
        const request: RoutineCommentChangeRequest = {
            schoolId: schoolId,
            classroomId: classroomId,
            studentId: studentId,
            eventDate: eventDate,
            routineId: item.routineId,
        };
        dispatch(routineCommentChange(
            {...request, comment: editingComment}
        ));
    };

    const handleRollback = () => {
        setEditingComment(routineComment || "");
    };

    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <Stack direction="column" alignItems="center" spacing={1} sx={{ flex: 1 }}>
                <Button variant="contained" color='success' onClick={handleSave} disabled={changing || !changed}>
                    <Tooltip title="Salvar comentário">
                        <CheckIcon />
                    </Tooltip>
                </Button>
                <Button variant="contained" color='error' onClick={handleRollback} disabled={changing || !changed}>
                    <Tooltip title="Cancelar edição">
                        <CloseIcon />
                    </Tooltip>
                </Button>
            </Stack>
            <TextField id="comment" name="comment" label="Observação"
                fullWidth autoComplete="" variant="standard"
                disabled={changing}
                multiline minRows={2} maxRows={4}
                value={editingComment}
                onChange={(e) => setEditingComment(e.target.value)} />
        </Stack>
    );
};

export default RoutineCommentCell;
